import { blend, clamp } from './interpolate';

const scoreB2bStandard = (share) => clamp(30 + share * 55, 0, 92);
const scoreFz = (share) => {
  if (share <= 0.1) return 90;
  if (share <= 0.25) return 90 - ((share - 0.1) / 0.15) * (90 - 70);
  if (share <= 0.5) return 70 - ((share - 0.25) / 0.25) * (70 - 45);
  return clamp(45 - (share - 0.5) * 60, 20, 45);
};
const scoreExport = (share) => {
  if (share <= 0.1) return 92;
  if (share <= 0.25) return 92 - ((share - 0.1) / 0.15) * (92 - 72);
  if (share <= 0.5) return 72 - ((share - 0.25) / 0.25) * (72 - 45);
  return clamp(45 - (share - 0.5) * 60, 20, 45);
};
const scoreRisky = (share) => clamp(95 - share * 200, 10, 95);

export const scoreD5 = (inputs) => {
  const b2b = scoreB2bStandard(inputs.standardB2bShare);
  const fz = scoreFz(inputs.freeZoneShare);
  const exp = scoreExport(inputs.exportShare);
  const risky = scoreRisky(inputs.riskyChannelShare);

  const score = blend([
    { score: b2b, weight: 0.45 },
    { score: fz, weight: 0.2 },
    { score: exp, weight: 0.2 },
    { score: risky, weight: 0.15 },
  ]);

  return { score, subScores: { b2b, fz, exp, risky } };
};
